import "./Layout.css"; 
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { useState } from "react";

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="layout-container">
      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <Sidebar />
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Topbar */}
        <div className="topbar">
          <Topbar />
          <button 
            className="btn btn-light d-md-none" 
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            ☰
          </button>
        </div>

        {/* Content */}
        <div className="content">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
